import axios from 'axios';

import errorMessage from 'Store/actions/errorMessage';
import {
  GET_HIPPODROMES,
  GET_HIPPODROMES_FAILURE,
  GET_HIPPODROMES_SUCCESS,
  GET_HIPPODROMES_BETS,
  GET_HIPPODROMES_BETS_FAILURE,
  GET_HIPPODROMES_BETS_SUCCESS,
  GET_HIPPODROMES_BET_DETAILS,
  GET_HIPPODROMES_BET_DETAILS_FAILURE,
  GET_HIPPODROMES_BET_DETAILS_SUCCESS,
  SET_SELECTED_HIPPODROME,
  SET_SELECTED_HIPPODROME_RACE_DATE,
  SET_SELECTED_BET_TYPE,
  SET_SELECTED_RACE_NUMBER,
  CHANGE_BULTEN_RACENUMBER,
  GET_ALL_HIPPODROMES,
  GET_ALL_HIPPODROMES_SUCCESS,
  GET_ALL_HIPPODROMES_FAILURE,
  SET_SELECTED_PROGRAM_LEG,
  GET_HOMEPAGE_HIPPODROMES,
  GET_HOMEPAGE_HIPPODROMES_SUCCESS,
  GET_HOMEPAGE_HIPPODROMES_FAILURE,
  TOGGLE_TJK_TV,
  SET_PROGRAM_TYPE,
  SET_FIXED_ODD_BADGE,
  SET_FIXED_ODD_INFO
} from 'Store/constants';


import {
  hippodromesMapper,
  availableBetsMapper,
  betDetailsMapper,
  findInHippodromeByKey,
  isStrictHippdrome
} from 'Utils/horseRacesNameMapper';
import {
  navigateWithParams,
  setSearchParams,
  getNavigateParams
} from 'Utils/horseRacingRouteHelper';
import { catchTJKError } from 'Utils/catchTJKError';
import { TJK_URL_SUFFIX } from 'Store/constants/horseRacing';
import { allHippodromesMapper } from 'Utils/horseRacesNameMapper';
import { setSelectedSixPickOrder } from './agfActions';
import { PROGRAM_TYPES } from 'Store/constants/horseRacing';
import ProjectConfig from 'ProjectConfig';

export const getAllHippodromes = () => async dispatch => {
  // tjk ya girildiğinde bu action çalışır. bir defa datayı çeker, bir daha çağırılmaz.
  try {
    dispatch({
      type: GET_ALL_HIPPODROMES,
    });

    const apiUrl = ProjectConfig.API_GATEWAY + '/mobile/tjk/hippodromes/all';
    const res = await axios.get(apiUrl);


    catchTJKError(res.data);


    const payload = allHippodromesMapper(res.data.body);

    dispatch({
      type: GET_ALL_HIPPODROMES_SUCCESS,
      payload: payload,
    });

  } catch (e) {
    dispatch({
      type: GET_ALL_HIPPODROMES_FAILURE,
      payload: e.response?.data || (e.message ? e : errorMessage),
    });
  }
};

export const getHomePageHippodromes = programType => async dispatch => {
  try {
    dispatch({
      type: GET_HOMEPAGE_HIPPODROMES,
    });

    let api;
    switch (programType) {
      case PROGRAM_TYPES.JOINT:
        api = '/mobile/tjk/hippodromes/v2';
        break;
      case PROGRAM_TYPES.FIXED:
        api = '/product/fixodds/hippodromes/v2';
        break;
      default:
        api = '/mobile/tjk/hippodromes/v2';
        break;
    }
    const res = await axios.get(api);

    catchTJKError(res.data);


    const payload = res?.data?.body?.h;

    dispatch({
      type: GET_HOMEPAGE_HIPPODROMES_SUCCESS,
      payload: payload,
    });

  } catch (e) {
    dispatch({
      type: GET_HOMEPAGE_HIPPODROMES_FAILURE,
      payload: e.response?.data || (e.message ? e : errorMessage),
    });
  }
};
export const getHippodromes = (raceDate, defaultHippodrome, programType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_HIPPODROMES,
    });
    const isStrict = isStrictHippdrome(defaultHippodrome?.key);
    let api;
    switch (programType) {
      case PROGRAM_TYPES.JOINT:
        api = ProjectConfig.API_GATEWAY + '/mobile/tjk/hippodromes/v2';
        break;
      case PROGRAM_TYPES.FIXED:
        api = ProjectConfig.API_GATEWAY + '/product/fixodds/hippodromes/v2';
        break;
      default:
        api = ProjectConfig.API_GATEWAY + '/mobile/tjk/hippodromes/v2';
        break;
    }
    const res = await axios.get(api, { params: { raceDate } });

    catchTJKError(res.data);

    const data = hippodromesMapper(res.data.body);
    const raceDay = res?.data?.body?.ad;
    dispatch({
      type: GET_HIPPODROMES_SUCCESS,
      payload: { data, raceDay },
    });

    let defaultSelected = null;

    const foundedFromParams = data.find(e => e.key === defaultHippodrome?.key); // defaultHippodromeKey varsa default seçili hippodrome yap

    if (isStrict && (defaultHippodrome?.fromPath && !foundedFromParams)) { // zorunlu hipodromlardan biri ise ve bu hipodrome bugun yoksa başka hipp seçme, hata sayfası göster
      throw ({ message: true, strictHippodromeError: true });
    }
    defaultSelected =     foundedFromParams || data.find(e => e.isSelected) || data[0]; // defaultHippodromeKey yoksa isSelected, yoksa ilk hippodrome yap

    const _mustPathChange = !defaultHippodrome?.key || data.find(e => e.isSelected)?.key === defaultHippodrome?.key; // bu hipodrome default ise path değiştirme

    dispatch(setSelectedHippodromeId(defaultSelected, _mustPathChange, programType));

  } catch (e) {
    dispatch({
      type: GET_HIPPODROMES_FAILURE,
      payload: e.response?.data || (e.message ? e : errorMessage),
    });
  }
};

export const setSelectedHippodromeId = (card, mustPathChange, programType) => async (dispatch, getState) => { // set default hippodrome and request for bets
  const allHippodromes = getState().horseRacing.allHippodromes;

  const hipp = findInHippodromeByKey(card.key, allHippodromes.data);
  const dontWatchPath = getNavigateParams().dwp;

  if (!mustPathChange && !dontWatchPath) { //isPathChange yoksa params update edilmez. ana sayfadaki /tjk/at-yarisi-bulteni sayfasını kırılımdan korumak için.
    const preparedParams = hipp?.location ? hipp.location + TJK_URL_SUFFIX.program.urlSuffix : '';
    hipp && navigateWithParams({ type: 'replace', params: preparedParams, search: '' });
    setSearchParams({ hpdm: hipp.location }); // hippodrom her değiştiğinde güncellenir.
  }

  try {
    dispatch({
      type: SET_SELECTED_HIPPODROME,
      payload: card.cardId || card.akey,
    });
    dispatch({
      type: SET_SELECTED_HIPPODROME_RACE_DATE,
      payload: card.raceDate,
    });
    dispatch(getHippodromesBets(card.cardId, card.akey, card.raceDate, programType));
  } catch (e) {
    //console.log('error', e);
  }
};

export const getHippodromesBets = (cardId, akey, date, programType) => async dispatch => {
  const raceDate = new Date(date).getTime(date);
  try {
    dispatch({
      type: GET_HIPPODROMES_BETS,
    });
    const params = cardId ? { cardId } : { akey, raceDate };
    let api;
    switch (programType) {
      case PROGRAM_TYPES.JOINT:
        api = `${ProjectConfig.API_GATEWAY}/mobile/tjk/hippodromes/bets/v2`;
        break;
      case PROGRAM_TYPES.FIXED:
        api = `${ProjectConfig.API_GATEWAY}/product/fixodds/hippodrome/bets/v2`;
        break;
      default:
        api = `${ProjectConfig.API_GATEWAY}/mobile/tjk/hippodromes/bets/v2`;
        break;
    }

    const res = await axios.get(api, { params });
    const payload = availableBetsMapper(res.data.body).filter(e=>e.clientOrder !== -1); // -1 order olanları sil

    catchTJKError(res.data);

    dispatch({
      type: GET_HIPPODROMES_BETS_SUCCESS,
      payload: payload,
    });

    const defaultSelected = payload.find(e => e.id === getNavigateParams().bt * 1) || payload.find(e => e.isSelected) || payload[0]; // getNavigateParams ta bt yoksa isSelected, yoksa ilk bt yap

    dispatch(setSelectedBetTypeId(defaultSelected, cardId, programType));

  } catch (e) {
    dispatch({
      type: GET_HIPPODROMES_BETS_FAILURE,
      payload: e.response?.data || (e.message ? e : errorMessage),
    });
  }
};

export const setSelectedBetTypeId = ( selected, _cardId, programType) => async (dispatch, getState) => { // set bt and request for bet details
  try {
    if (!_cardId) {
      _cardId = getState().horseRacing.hippodromesInfo.selectedHippodromeId;
    }

    if (selected ) {
      setSearchParams({ bt: selected.id });
    }

    dispatch({
      type: SET_SELECTED_BET_TYPE,
      payload: selected.id,
    });

    const selectedRace = selected.selectableRaces.find(e=>e.value === getNavigateParams().rt ) || selected.selectableRaces.find(e=>e.isSelected) || selected.selectableRaces[0];  // getNavigateParams ta rt yoksa veya o bettype requestten dönmediyse, isSelected, yoksa ilk rt yap
    if (selectedRace) {
      if (selectedRace?.sixPickOrder) {
        dispatch(setSelectedSixPickOrder(selectedRace?.sixPickOrder));
      } else {
        dispatch(setSelectedSixPickOrder(2));
      }
      dispatch(setSelectedRaceNumber( selectedRace.value, _cardId, programType)); // set default race number
    }

  } catch (e) {
    //console.log('error', e);
  }
};

export const setSelectedRaceNumber = ( selectedValue, _cardId, programType) => async (dispatch, getState) => { // set selectedRaceNumber and request for bet details
  try {
    const _betTypeId = getState().horseRacing.hippodromeAvailableBets.selectedBetTypeId;
    if (!_cardId) {
      _cardId = getState().horseRacing.hippodromesInfo.selectedHippodromeId;
    }

    if (selectedValue) {
      setSearchParams({ rt: selectedValue });
    }


    dispatch({
      type: SET_SELECTED_RACE_NUMBER,
      payload: selectedValue,
    });

    dispatch({
      type: CHANGE_BULTEN_RACENUMBER,
      payload: { hpdm: _cardId, bt: _betTypeId, rt: selectedValue },
    });

    dispatch(getHippodromeBetDetails(_cardId, _betTypeId, selectedValue, programType));

  } catch (e) {
    //console.log('error', e);
  }
};

export const getHippodromeBetDetails = (cardId, betTypeId, selectedRace, programType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_HIPPODROMES_BET_DETAILS,
    });
    const raceDate = new Date(getState().horseRacing.hippodromesInfo.selectedHippodromeRaceDate).getTime();
    const isNextDay = typeof cardId === 'string';
    const params = isNextDay ? { akey: cardId, betTypeId, selectedRace, raceDate } : { cardId, betTypeId, selectedRace };
    let api;
    switch (programType) {
      case PROGRAM_TYPES.JOINT:
        api = ProjectConfig.API_GATEWAY + '/mobile/tjk/hippodromes/bets/races/v2';
        break;
      case PROGRAM_TYPES.FIXED:
        api = ProjectConfig.API_GATEWAY + '/product/fixodds/hippodrome/bets/races/v2';
        break;
      default:
        api = ProjectConfig.API_GATEWAY + '/mobile/tjk/hippodromes/bets/races/v2';
        break;
    }
    const res = await axios.get(
      api, { params });
    if (programType === PROGRAM_TYPES.FIXED) {
      const { fixoddsBadge, infos } = res.data.body;
      dispatch({
        type: SET_FIXED_ODD_BADGE,
        payload: fixoddsBadge,
      });
      dispatch({
        type: SET_FIXED_ODD_INFO,
        payload: infos,
      });
    }
    const payload = betDetailsMapper(res.data.body);
    catchTJKError(res.data);

    dispatch({
      type: GET_HIPPODROMES_BET_DETAILS_SUCCESS,
      payload: payload,
    });

    if (getNavigateParams()?.ln) { // search params legNo var ise default seçili legNo yap
      const legIndex = getNavigateParams()?.li * 1 || 1;
      dispatch(setSelectedProgramLeg({ index: legIndex, ...payload.legs.find(e=>e.legNo === getNavigateParams().ln * 1 ) }));
    } else { // search params legNo yok ise default seçili 0. leg
      dispatch(setSelectedProgramLeg({ index: 1, ...payload.legs[0] }));
      setSearchParams({ ln: payload.legs[0].legNo });
    }

  } catch (e) {
    dispatch({
      type: GET_HIPPODROMES_BET_DETAILS_FAILURE,
      payload: e.response?.data || (e.message ? e : errorMessage),
    });
  }
};

export const setSelectedProgramLeg = data => async dispatch => { // set selectedLeg for display at program
  try {
    if (!data) {
      return;
    }

    dispatch({
      type: SET_SELECTED_PROGRAM_LEG,
      payload: data,
    });

  } catch (e) {
    //console.log('error', e);
  }
};

export const toogleTjkTv = data => async dispatch => {
  dispatch({
    type: TOGGLE_TJK_TV,
    payload: data,
  });

};

export const setProgramType = type => async dispatch => {
  dispatch({
    type: SET_PROGRAM_TYPE,
    payload: type,
  });
};
